export default {
  ONLINE: "Online",
  OFFLINE: "Offline",
  RETEST: "Retest",
  APP_STATUS: "App Status",
  DNS_IP_COMPARE: "Dns Ip Compare",
  VERSIONS: "Versions",
  TRACKING_CAMERA: "Tracking Camera",
  COURT_LIMITS: "Court Limits",
  RTSP: "RTSP",
  INTERNAL_IPS: "Camera Internal Ips",
  EXTERNAL_PORTS: "External Ports",
  SSH_CONNECTION: "SSH Connection",
  SITE_DONGLE: "Site Dongle",
  OUTSIDE_ACCESS: "Outside Access",
  COMMUNICATION_FILE: "Communication File",
  PORT: "Port",
  IP: "IP",
  STATUS: "Status",
  RECORD: "Record Status",
  TEST_RECORD: "Record Test",
  LIVE_STATUS: "Live Status",
  TEST_LIVE: "Live Test ",
  LOGIN: "Login",
  LOGOUT: "Logout",
  SITES_TESTING: "SITES TESTING",
  SITE_OFFLINE: "Site Is Offline",
  SPEED_TEST: "Speed Test",
  START_TESTING: "Select site above to start testing...",
  TEST_FAILED: "Test failed",
  DOCKER_IMAGES: "Docker Images",
  DOCKER_NAME: "Docker Name",
  SCORE_CAMERA: "Score Camera",
  PERSPECTIVE_COORDS: "Perspective Coords"
};
